import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from 'react';
import InitErrorMessage from './InitErrorMessage';
/**
 * Component to handled react errors.
 * This is not functional component since only class components support this.
 */
export default class GeneralErrorBoundary extends Component {
    state = {
        error: null,
    };
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (_jsx(InitErrorMessage, { error: this.state.error, message: "React lifecycle error." }, void 0));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=GeneralErrorBoundary.js.map